import Facilities from './components/Facilities';

export default Facilities;
